import { api } from './networkService';

class ExpenseService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/expense/expense`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch expense error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/expense/expense`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch expense error:', error);
            throw error;
        }
    }

    static async add(expense) {
        try {
            const cleanedExpense = Object.fromEntries(
                Object.entries(expense).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/expense/expense`, cleanedExpense);
            return response;
        } catch (error) {
            console.error('Add expense error:', error);
            throw error;
        }
    }

    static async update(expense) {
        try {
            const { id, ...info } = expense;
            const cleanedExpense = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );

            const response = await api.put(`api/user/expense/expense/${id}`, cleanedExpense);
            return response;
        } catch (error) {
            console.error('Update expense error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/expense/expense/${id}`);
            return response;
        } catch (error) {
            console.error('Delete expense error:', error);
            throw error;
        }
    }
}

export default ExpenseService;
